import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth";

export {
  default as Auth,
  CognitoError,
  getAccessToken,
  getExpiration,
  Hub,
} from "./Auth";
export {
  AuthContext,
  AuthState,
  AuthProvider,
  useAuthContext,
  useAuthState,
} from "./AuthContext";
export { mockAuth } from "./mockAuth";

const CognitoAuthProvider = {
  Apple: CognitoHostedUIIdentityProvider.Apple,
  Facebook: CognitoHostedUIIdentityProvider.Facebook,
  Google: CognitoHostedUIIdentityProvider.Google,
};
export { CognitoAuthProvider };
